import React from "react";
import { Box } from "theme-ui";
import { Heading } from "@loanpal/lumos__core";
import { Text } from "@aws-amplify/ui-react";
import logo from "../../images/goodleap-white-orange.svg";

const ComingSoon = () => {

  return (
    <Box
      sx={{
        maxWidth: "100%",
        backgroundColor: "#ffffff",
        mx: "auto",
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box>
        <Heading
          className="heading-box"
          sx={{
            width: "960px",
            margin: "0 auto",
            backgroundColor: "#003439",
          }}
        >
          <img src={logo} alt="GoodLeap" style={styles.logo} />
        </Heading>
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '40px 20px'
        }}
      >
        <Box
          sx={{
            fontSize: '80px',
            marginBottom: '30px',
            color: '#FF6B35',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
                opacity: 1
              },
              '50%': {
                transform: 'scale(1.1)',
                opacity: 0.8
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 1
              }
            },
            animation: 'pulse 2s infinite'
          }}
        >
          🚧
        </Box>
        <Heading variant="h2" sx={{ marginBottom: '20px', color: '#003439' }}>
          Coming Soon
        </Heading>
        <Text sx={{ fontSize: '18px', color: '#666' }}>
          This feature is going through some changes. Please check back soon.
        </Text>
      </Box>
    </Box>
  );
};

const styles = {
  logo: {
    width: 250,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 10,
  }
};

export default ComingSoon;